var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_307_2279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 9.52416C2.09925 10.0686 1.3335 10.8274 1.3335 11.6666C1.3335 13.3234 4.31826 14.6666 8.00016 14.6666C11.6821 14.6666 14.6668 13.3234 14.6668 11.6666C14.6668 10.8274 13.9011 10.0686 12.6668 9.52416M12.0002 5.33325C12.0002 8.04239 9.00016 9.33325 8.00016 11.3333C7.00016 9.33325 4.00016 8.04239 4.00016 5.33325C4.00016 3.12411 5.79102 1.33325 8.00016 1.33325C10.2093 1.33325 12.0002 3.12411 12.0002 5.33325ZM8.66683 5.33325C8.66683 5.70144 8.36835 5.99992 8.00016 5.99992C7.63197 5.99992 7.3335 5.70144 7.3335 5.33325C7.3335 4.96506 7.63197 4.66659 8.00016 4.66659C8.36835 4.66659 8.66683 4.96506 8.66683 5.33325Z",
    stroke: "#405BD8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_307_2279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.e1cee244776ffef2f57e3b512efd2765.svg";
export { ForwardRef as ReactComponent };